import React from 'react';
import { Box, Typography, Modal, Button, Chip } from '@mui/material';
import { ShoppingCart, MenuBook } from '@mui/icons-material';

const EBookModal = ({ open, onClose, title, author, excerpt, price, priceDisplay, coverImageUrl }) => (
  <Modal
    open={open}
    onClose={onClose}
    sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', p: 2 }}
  >
    <Box sx={{ 
      bgcolor: 'background.paper', 
      borderRadius: 3, 
      boxShadow: 8, 
      p: { xs: 3, sm: 5 }, 
      minWidth: { xs: '90vw', sm: 500, md: 600 }, 
      maxWidth: '95vw',
      maxHeight: '90vh',
      overflow: 'auto',
      display: 'flex', 
      flexDirection: 'column',
      gap: 3
    }}>
      <Typography variant="h5" fontWeight={700} color="primary" sx={{ textAlign: 'center', mb: 1 }}>
        <MenuBook sx={{ mr: 1, verticalAlign: 'middle' }} />
        Purchase EBook
      </Typography>
      
      {/* Book Cover and Details */}
      <Box sx={{ display: 'flex', gap: 3, flexDirection: { xs: 'column', sm: 'row' } }}>
        {coverImageUrl && (
          <Box sx={{ 
            flexShrink: 0,
            alignSelf: { xs: 'center', sm: 'flex-start' }
          }}>
            <img 
              src={coverImageUrl} 
              alt={title}
              style={{
                width: '120px',
                height: '180px',
                objectFit: 'cover',
                borderRadius: '8px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
              }}
            />
          </Box>
        )}
        
        <Box sx={{ flex: 1 }}>
          <Typography variant="h6" fontWeight={600} color="text.primary" gutterBottom>
            {title}
          </Typography>
          
          <Typography variant="subtitle1" color="text.secondary" gutterBottom>
            by {author}
          </Typography>
          
          {excerpt && (
            <Typography variant="body2" color="text.secondary" paragraph sx={{ lineHeight: 1.6 }}>
              {excerpt}
            </Typography>
          )}
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 2 }}>
            <Typography variant="h5" fontWeight={700} color="primary">
              {priceDisplay}
            </Typography>
            <Chip 
              label="Digital Download" 
              size="small" 
              color="secondary" 
              variant="outlined"
            />
          </Box>
        </Box>
      </Box>

      {/* Purchase Info */}
      <Box sx={{ 
        bgcolor: 'rgba(69,123,157,0.07)', 
        borderRadius: 2, 
        p: 3, 
        textAlign: 'center' 
      }}>
        <Typography variant="body1" color="text.primary" gutterBottom>
          You will receive a download link after payment completion.
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Compatible with all devices • PDF format • Instant delivery
        </Typography>
      </Box>

      {/* Purchase Note */}
      <Box sx={{ 
        bgcolor: 'rgba(244, 162, 97, 0.1)', 
        borderRadius: 2, 
        p: 2, 
        textAlign: 'center', 
        border: '1px solid rgba(244, 162, 97, 0.3)'
      }}>
        <Typography variant="body2" color="primary.main" fontStyle="italic">
          Stripe payment integration coming soon
        </Typography>
      </Box>
      
      {/* Action Buttons */}
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
        <Button 
          variant="outlined" 
          color="primary" 
          sx={{ borderRadius: 999, fontWeight: 600, minWidth: 120 }} 
          onClick={onClose}
        >
          Maybe Later
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          startIcon={<ShoppingCart />}
          sx={{ borderRadius: 999, fontWeight: 600, minWidth: 120 }} 
          onClick={onClose}
        >
          Buy Now
        </Button>
      </Box>
    </Box>
  </Modal>
);

export default EBookModal; 